<script setup lang="ts">
import { onMounted, reactive, ref } from 'vue';
import { useRouter } from 'vue-router';

import headerCommonVue from '@/fe_modules/components/header-common.vue';

import { goToTest, startTest } from '../api/question';
onMounted(() => {
  getTestInfo();
  console.log(window.location.origin);
});
const router = useRouter();
const checked = ref(false);
const taskInfo = reactive<any>({ data: {} });

const getTestInfo = () => {
  goToTest({})
    .then((res: any) => {
      if (res.data) {
        taskInfo.data = res.data;
      }
    })
    .catch((err: any) => {
      window.location.href = '/users/test';
    });
};

// 开始答题按钮开关，防重复点击
let flag = true;
// 开始答题
const start = () => {
  if (flag) {
    flag = false;
    startTest({
      applyId: taskInfo.data.applyId
    })
      .then(() => {
        flag = true;
        router.push({
          path: '/test/dot/startDotChoiceTest',
          query: {
            applyId: taskInfo.data.applyId,
            subjectType: 1
          }
        });
      })
      .catch(() => {
        flag = true;
      });
  }
};
</script>
<template>
  <div>
    <headerCommonVue />
    <div class="section">
      <div class="content">
        <p class="explain">轻任务测试：{{ taskInfo.data.title }}</p>
        <div class="main m-t-20">
          <div class="pic">
            <img src="../assets/image/dot_img.png" width="320" height="" />
          </div>
          <div class="info">
            <h3>通过轻任务权限测试，才能获得轻任务接单权限</h3>
            <h4 class="m-t-20">
              测试题合计耗时<span
                >{{ taskInfo.data.predictTime / 1000 / 60 }}分钟</span
              >，内容包含：
            </h4>
            <p class="m-t-10">
              ●&nbsp;随机翻译题：{{ taskInfo.data.peCount }}题/{{
                taskInfo.data.peDuration / 1000 / 60
              }}分钟，超时则直接测试失败&nbsp;&nbsp;&nbsp;●&nbsp;随机打标题：{{
                taskInfo.data.markCount
              }}题/{{
                taskInfo.data.markDuration / 1000 / 60
              }}分钟，超时则直接测试失败
            </p>
            <hr />
            <h4>
              您有<span>{{ taskInfo.data.limitTimes }}</span
              >次测试机会，这是第<span>{{ taskInfo.data.testTimes }}</span
              >次
            </h4>
            <p class="m-t-10">
              ●&nbsp;开始测试后，请不要退出，否则将损失1次测试机会
            </p>
            <div class="m-t-10">
              <a-checkbox
                v-model:checked="checked"
                :disabled="taskInfo.data.limitTimes < taskInfo.data.testTimes"
                class="checkbox"
                >我同意不分享本机测试的任何内容，并且接受此测试结果为最终结果</a-checkbox
              >
              <div class="m-t-20">
                <a-button
                  type="primary"
                  size="large"
                  class="b-r-10"
                  :disabled="!checked || taskInfo.data.status === '40'"
                  @click="start"
                  >开始测试</a-button
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.section {
  background: url(../assets/image/question_bg.jpg) no-repeat center center;
  background-size: cover;
  width: 100%;
  height: calc(100vh - 0px);
  padding-top: 70px;
  .content {
    width: 1000px;
    margin: 0 auto;
    .explain {
      padding: 30px 0 20px 0;
      font-size: 16px;
      color: #7c7c7c;
      border-bottom: 1px solid #e0e0e0;
    }
    .main {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      .pic {
      }
      .info {
        h3 {
          font-size: 18px;
          font-weight: bold;
        }
        h4 {
          span {
            color: var(--color-theme-2);
          }
        }
        p {
          color: #555;
        }
        hr {
          border: 0;
          border-top: solid 1px #e0e0e0;
          margin: 20px 0;
        }
        .checkbox {
          color: #7c7c7c;
        }
      }
    }
  }
}
</style>
